import { Box, styled } from '@mui/material'

const AppLayout = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export default AppLayout
